<template>
  <div>
    <template v-for="file in fileGroups.Vertrag">
      <v-tooltip :key="`file_${file.id}`" bottom>
        <template #activator="{ on, attrs }">
          <v-icon
            class="mr-3"
            :color="!file.path ? 'error' : 'success'"
            v-bind="attrs"
            v-on="on"
            v-text="getIconForTitle(file.title)"
          />
        </template>
        {{ file.title }}
      </v-tooltip>
    </template>
    <v-menu
      v-if="otherFilesLength > 0"
      bottom
    >
      <template #activator="{ on: onMenu, attrs: attrMenu }">
        <v-tooltip bottom>
          <template #activator="{ on: onTooltip, attr: attrTooltip }">
            <v-badge
              :content="otherFilesLength"
              :value="otherFilesLength"
              color="secondary"
              text="white"
              overlap
            >
              <span slot="badge">{{ otherFilesLength }}</span>
              <v-icon
                :color="otherFilesLengthOpen > 0? 'error': 'success'"
                v-bind="{ ...attrMenu, ...attrTooltip }"
                v-on="{ ...onMenu, ...onTooltip }"
                v-text="'mdi-plus'"
              />
            </v-badge>
          </template>
          <span>weitere Dateien</span>
        </v-tooltip>
      </template>
      <v-list dense>
        <template
          v-for="(file_group_items, file_group) in otherFileGroups"
        >
          <v-subheader :key="`header_${file_group}`" class="text-body-2">
            {{ file_group }}
          </v-subheader>
          <v-list-item
            v-for="file in file_group_items"
            :key="`file_${file.id}`"
          >
            <v-list-item-icon>
              <v-icon
                :color="!file.path ? 'error' : 'success'"
                v-text="!file.path ? 'mdi-alert-circle' : 'mdi-check'"
              />
            </v-list-item-icon>
            <v-list-item-content class="text-caption" v-text="file.title" />
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
   props: {
      fileGroups: {
         type: Object,
         required: true,
      },
   },
   computed: {
      otherFileGroups () {
         const filtered = Object.entries(this.fileGroups).filter(
            ([file_group, file_group_items]) => file_group !== 'Vertrag'
         )
         return Object.fromEntries(filtered)
      },
      otherFilesLength () {
         const values = Object.values(this.otherFileGroups)
         const flattened = values.flat()
         return flattened.length
      },
      otherFilesLengthOpen () {
         const values = Object.values(this.otherFileGroups)
         const flattened = values.flat()
         const filtered = flattened.filter(
            (file) => !file.path
         )
         return filtered.length
      }
   },
   methods: {
      filterObjectByKey (object, key) {
         const filtered = Object.entries(object).filter(
            ([file_group, file_group_items]) => file_group !== key
         )
         return Object.fromEntries(filtered)
      },
      flattenNestedObjectArray (object) {
         const values = Object.values(object)
         return values.flat()
      },
      countRequiredFiles (requiredFileGroups) {
         return this.flattenNestedObjectArray(requiredFileGroups).length
      },
      countOpenRequiredFiles (requiredFileGroups) {
         const filtered = this.flattenNestedObjectArray(requiredFileGroups).filter(
            (file) => !file.path
         )
         return filtered.length
      },
      getIconForTitle (title) {
         let icon = ''
         switch (title) {
         case 'Unterschrift Telekom (DIVE)':
         case 'Telekom-Unterschrift':
            icon = 'mdi-draw'
            break
         case 'Bestellung BFI':
            icon = 'mdi-file-undo-outline'
            break
         default:
            icon = 'mdi-file-outline'
            break
         }
         return icon
      },
   },
}
</script>

<style>
</style>
